import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSessionTracksReport, getResidentSessionReport } from "../../api"
import _ from "lodash";
import { SCREENS } from "../../constants";
import { setMoodEnergyChartData, setStressMeterData, setWellbeingMeterData } from "../top"
import { parseContentTableData, parseContentTopData } from "../../parsers"

export const getContentTopData = createAsyncThunk('content/getTopData', async (data) => {
    const { startDate, endDate, compareTrendKey, residentId, sessionId } = data
    const res = await getResidentSessionReport(startDate, endDate, compareTrendKey, residentId, sessionId)
    const parsedData = parseContentTopData(res.data)
    return parsedData
})

export const getContentTableData = createAsyncThunk('content/getTableData', async (data) => {
    const { startDate, endDate, compareTrendKey, residentId, sessionId, page, pageSize } = data
    const response = await getSessionTracksReport(startDate, endDate, compareTrendKey, residentId, sessionId, page, pageSize)
    const parsed = parseContentTableData(response.data)
    return { data: parsed, pagination: response.pagination };
})
